export const throttle = 300;

export const STAGE_ARTA_API_KEY = 'yUwdE1y92YmfXn1P8ScfyXUS';
export const PROD_ARTA_API_KEY = 'LwpxltzCv0rApElv0K0dtrjY';
